import Cashback, { QUERY } from 'components/pages/Cashback/Cashback';
import { buildPage, buildQueryPreloader } from 'utils/pageHelper';
import { GetStaticPaths } from 'next/types';
import OFFER_CATEGORIES from 'constants/offerCategories';
import { PROMOTION_TAG } from 'utils/offers';

export default buildPage(Cashback, {
  withNestedMetaData: true,
});

function generateCategories(locale: string | undefined = undefined) {
  return OFFER_CATEGORIES.map((category) => ({
    params: { category: category.tag },
    locale,
  }));
}

export const getStaticPaths: GetStaticPaths = async function getStaticPaths(context) {
  const categories = (context.locales || []).reduce(
    (acc, locale) => [...acc, ...generateCategories(locale)],
    generateCategories(),
  );
  return {
    paths: categories,
    fallback: false,
  };
};
export const getStaticProps = buildQueryPreloader(QUERY, (context) => ({
  requiredTags: [context.params?.category],
  promoTags: [context.params?.category, PROMOTION_TAG],
}));
